import { MapContainer, TileLayer, Marker, Popup, Tooltip } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const dot = (color, size) =>
  L.divIcon({
    className: "nola-pin",
    html: `<div style="width:${size}px;height:${size}px;background:${color};border:2px solid #fff;border-radius:50%;box-shadow:0 0 0 3px ${color}40,0 2px 6px rgba(0,0,0,.35)"></div>`,
    iconSize: [size, size],
    iconAnchor: [size / 2, size / 2],
  });

const SUBJECT = L.divIcon({
  className: "nola-pin",
  html: `<div style="display:flex;align-items:center;justify-content:center;width:34px;height:34px;background:#0F2E23;border:2px solid #C59B27;border-radius:50% 50% 50% 0;transform:rotate(-45deg);box-shadow:0 4px 10px rgba(0,0,0,.35)"><div style="transform:rotate(45deg);color:#D4AF37;font:700 10px 'JetBrains Mono',monospace">SITE</div></div>`,
  iconSize: [34, 34],
  iconAnchor: [17, 34],
});

export default function LocationMap({ subject, points = [], height = 440, color = "#3E5C4E", testId = "location-map" }) {
  if (!subject) return null;
  const valid = points.filter((p) => Number.isFinite(p.lat) && Number.isFinite(p.lng));
  return (
    <div className="rounded-lg overflow-hidden border border-[#E2DCD2]" style={{ height }} data-testid={testId}>
      <MapContainer center={[subject.lat, subject.lng]} zoom={15} scrollWheelZoom={false} style={{ height: "100%", width: "100%" }}>
        <TileLayer attribution='&copy; OpenStreetMap contributors' url="https://tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <Marker position={[subject.lat, subject.lng]} icon={SUBJECT} zIndexOffset={1000}>
          <Tooltip direction="top" offset={[0, -30]} permanent={false}>{subject.label}</Tooltip>
          <Popup><strong>{subject.label}</strong><br />Subject property</Popup>
        </Marker>
        {valid.map((p, i) => (
          <Marker key={`${p.name}-${i}`} position={[p.lat, p.lng]} icon={dot(p.color || color, 16)}>
            <Tooltip direction="top" offset={[0, -8]}>{p.name}</Tooltip>
            <Popup><strong>{p.name}</strong>{p.description && <><br />{p.description}</>}</Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
